import React from 'react';
import { Home } from './pages/Home';
export function App() {
  return <Home data-id="element-0" data-mp="odhoj3frwuc1" />;
}